import { Table } from 'antd';
import React from 'react'

const CustomerEmail = ({ dataSource, CustomerId }) => {
console.log(CustomerId);

    const data = dataSource.map((item, index) => ({ ...item, key: index + 1 }))

    const columns = [
        {
            dataIndex: "key",
            title: "#",
            key: "key",
        },
        {
            dataIndex: "Email",
            title: "Email",
            key: "Email",
        },
        {
            dataIndex: "ContactName",
            title: "Contact Name",
            key: "ContactName",
        },
    ];

    return (
        <Table
            columns={columns}
            dataSource={data}
            scroll={{ x: 'max-content' }}
        />
    )
}

export default CustomerEmail